import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-background-300 bg-background-200">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-14">
        <div className="flex flex-col gap-10 lg:flex-row lg:gap-16">
          <div className="lg:w-[36%]">
            <Link to="/" className="flex cursor-pointer items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-leaf-line text-lg" />
              </span>
              <span className="flex flex-col leading-none text-foreground-950">
                <span className="font-heading text-xl font-bold tracking-tight">枫与铃</span>
                <span className="mt-1 text-[9px] uppercase tracking-[0.3em] text-foreground-500">
                  Feng &amp; Ling
                </span>
              </span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              一个专注于影视推荐与影视资讯的内容平台，覆盖电影、电视剧、综艺等类型。我们希望把值得看的故事，认真地介绍给你。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-line", "ri-wechat-line", "ri-bilibili-line", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600"
                >
                  <i className={`${icon} text-base`} />
                </span>
              ))}
            </div>
          </div>

          <div className="grid flex-1 grid-cols-2 gap-8 sm:grid-cols-3">
            <div>
              <h4 className="mb-3 font-heading text-sm font-semibold text-foreground-950">
                <span>浏览影视</span>
              </h4>
              <ul className="space-y-2.5 text-sm text-foreground-600">
                <li>
                  <Link to="/category/movie" className="cursor-pointer hover:text-primary-600">
                    电影推荐
                  </Link>
                </li>
                <li>
                  <Link to="/category/tv" className="cursor-pointer hover:text-primary-600">
                    电视剧追剧
                  </Link>
                </li>
                <li>
                  <Link to="/category/variety" className="cursor-pointer hover:text-primary-600">
                    热门综艺
                  </Link>
                </li>
                <li>
                  <Link to="/favorites" className="cursor-pointer hover:text-primary-600">
                    我的收藏
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="mb-3 font-heading text-sm font-semibold text-foreground-950">
                <span>影视资讯</span>
              </h4>
              <ul className="space-y-2.5 text-sm text-foreground-600">
                <li>
                  <Link to="/news" className="cursor-pointer hover:text-primary-600">
                    最新资讯
                  </Link>
                </li>
                <li>
                  <Link to="/news?category=预告" className="cursor-pointer hover:text-primary-600">
                    新片预告
                  </Link>
                </li>
                <li>
                  <Link to="/news?category=评论" className="cursor-pointer hover:text-primary-600">
                    深度评论
                  </Link>
                </li>
                <li>
                  <Link to="/news?category=采访" className="cursor-pointer hover:text-primary-600">
                    创作者采访
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="mb-3 font-heading text-sm font-semibold text-foreground-950">
                <span>友情链接</span>
              </h4>
              <ul className="space-y-2.5 text-sm text-foreground-600">
                <li>
                  <Link to="/topic/topic-01" className="cursor-pointer hover:text-primary-600">
                    秋夜治愈片单
                  </Link>
                </li>
                <li>
                  <Link to="/topic/topic-02" className="cursor-pointer hover:text-primary-600">
                    迷雾追凶指南
                  </Link>
                </li>
                <li>
                  <Link to="/topic/topic-03" className="cursor-pointer hover:text-primary-600">
                    华语新力量
                  </Link>
                </li>
                <li>
                  <Link to="/search" className="cursor-pointer hover:text-primary-600">
                    全站搜索
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 rounded-md border border-background-300 bg-background-50/70 px-4 py-3 text-xs leading-relaxed text-foreground-500">
          本站为影视资讯与推荐演示站点，所有影视作品、评分、人物及资讯内容均为虚构示例，不提供在线播放、下载与支付服务。图片仅用于版式演示。
        </div>

        <div className="mt-6 flex flex-col items-start justify-between gap-3 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center">
          <span>© 2026 枫与铃 Feng &amp; Ling · 影视推荐与资讯平台</span>
          <div className="flex flex-wrap items-center gap-4">
            <span className="cursor-pointer hover:text-primary-600">关于我们</span>
            <span className="cursor-pointer hover:text-primary-600">内容声明</span>
            <span className="cursor-pointer hover:text-primary-600">联系我们</span>
          </div>
        </div>
      </div>
    </footer>
  );
}